import styled, { css } from 'styled-components'

import { buttonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const PrimaryButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.primary

    return css`
      ${buttonColorCSS(button, {
        loader: {
          background: button.background.disabled,
          color: button.content.default,
        },
      })}

      &[disabled] {
        background-color: ${button.background.disabled};
      }
    `
  }}
`
